import { render, staticRenderFns } from "./ModModifiElimAct.vue?vue&type=template&id=6ab4dfc4"
import script from "./ModModifiElimAct.vue?vue&type=script&lang=js"
export * from "./ModModifiElimAct.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports